import React, {useCallback} from 'react'
import {Paragraph} from 'common/components'
import {TemplateDropboxContentPreview} from 'pages/templates'

export default function DropboxCreationPreview() {
  const renderHeader = useCallback(
    () => (
      <div>
        <Paragraph fontSize="m" fontWeight="bold" color="gray_5">
          Monday, 4 Sep 2023, 13:00
        </Paragraph>
        <Paragraph fontSize="l" fontWeight="medium">
          2000 photos uploaded
        </Paragraph>
      </div>
    ),
    [],
  )

  return (
    <TemplateDropboxContentPreview
      data={[]}
      renderHeader={renderHeader}
      keyExtractor={(_, i) => i.toString()}
    />
  )
}
